
export const text = `

[ID: A photo of a cheeseburger. The bread bun twists into the shape of a triangle; the ingredients around it wrap themselves alongside it, not accounting for any laws of physics. Someone has already taken a bite. It appears they used the ketchup package.]

`